import '../iron-collapse/iron-collapse';
import { LitElement, html } from 'lit';
import styles from './fit-collapse.css';

/**
 * Element to hide some content until a trigger is clicked, at which point the hidden content becomes visible
 *
 * @element fit-collapse
 */
class FitCollapse extends LitElement {
  static get is() { return 'fit-collapse'; }

  static get styles() { return styles; }

  render() {
    return html`
    <div>
      <slot name="trigger-outside"></slot>
    </div>

    <iron-collapse id="collapse" .opened="${this.opened}" @opened-changed="${this._updateOpened}">
      <slot></slot>
    </iron-collapse>

    <div>
      <slot name="trigger-outside-below"></slot>
    </div>
    `;
  }

  static get properties() {
    return {

      /**
       * Define if the element is collapsed or open
       */
      opened: {
        type: Boolean,
        reflect: true,
      },

      /**
       * Name for the collapsible group, so several elements (with dame groupIdentifier) can be open and closed with same trigger click
       */
      groupIdentifier: {
        type: String,
        attribute: 'group-identifier',
      },

    };
  }

  constructor(props) {
    super(props);
    this.opened = false;
    this.addEventListener('click', this.handleTriggerClick);
  }

  _updateOpened(event) {
    const opened = event.detail.value;
    if (this.opened != opened) {
      this.opened = opened;
    }
    this.closeOtherCollapsesInGroup(this.opened);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('initialized', '');
  }

  /**
   * @param {MouseEvent} event
   */
  handleTriggerClick(event) {
    if (null == event.target) {
      return;
    }
    if (event.target instanceof HTMLAnchorElement && event.target.getAttribute('href') !== '#') {
      return;
    }
    if (!Boolean(event.target.closest('[slot="trigger-outside"],[trigger-inside],[slot="trigger-outside-below"]'))) {
      return;
    }

    event.preventDefault();
    this.opened = !this.opened;
  }

  closeOtherCollapsesInGroup(opened) {
    if (this.groupIdentifier && opened) {
      let parentNode = this;
      let parentDocument;
      while ((parentNode = parentNode.parentNode)) {
        parentDocument = parentNode;
      }

      Array.prototype.forEach.call(
        (parentDocument || document).querySelectorAll(`fit-collapse[group-identifier="${this.groupIdentifier}"][opened]`),
        (collapseEl) => {
          if (collapseEl !== this) {
            collapseEl.opened = false;
          }
        },
      );
    }
  }
}

customElements.define(FitCollapse.is, FitCollapse);
